module.exports = __webpack_public_path__ + "img/card4.da7358fb.png";